<template>
    <div class="home-box">
        <tabs v-model="active" class="my-tabs" animated id="my-tabs">
            <tab :title="v.label" v-for="(v,i) in columnList" :key="i">
                <component :is="v.path" :activityId="v.id"></component>
            </tab>
        </tabs>
    </div>
</template>

<script>
    import {Tab, Tabs} from 'vant';
    import home from "../app/home";
    import homeB from "./homeB";
    import footTM from "../../common/footTM";
    import service from "../../api/service";
    

    export default {
        name: "homeA",
        components: {
            Tab, Tabs, home, homeB, footTM
        },
        data() {
            return {
                active: 0,
                columnList: [],//顶部菜单览列表
            }
        },
        mounted() {
            this.init();
        }, methods: {
            //查询顶部菜单览列表
            init() {
                service.get('/api/xw/topTitleBar', {position: '顶部导航栏'}).then(res => {
                    if (res.status === 200) {
                        let arr = [{
                            label: '推荐内容',
                            path: 'home'
                        }]
                        res.data.forEach(v => {
                            arr.push({
                                label: v.xwName,
                                id: v.id,
                                path: 'homeB',
                            })
                        })
                        this.columnList = arr
                    }
                })
            }
        }
    }
</script>

<style scoped>

    .my-tabs {
        width: 100%;
        /* position: absolute;
        top: 56px; */
    }
</style>